<!-- @format -->
<orders>
    <div class="container_sort margin-spacing-2_bottom">
        <div class="box_sort">
            <div class="sort-menu margin-spacing-2_right">
                <select name="sort" class="sort-list" name="state" onchange={(e)=>changeOrderState(e)}>
                    <option value="">全て</option>
                    <option value="400">制作物提出待ち</option>
                    <option value="500">納品完了</option>
                </select>
            </div><!--/.sort-menu-->
            <div class="sort-menu">
                <select name="sort" class="sort-list" name="ym" onchange={(e)=>changeOrderYm(e)}>
                    <option value="">全て</option>
                    <option value="2021-02">2021-02</option>
                    <option value="2021-01">2021-01</option>
                    <option value="2020-12">2020-12</option>
                    <option value="2020-11">2020-11</option>
                    <option value="2020-10">2020-10</option>
                    <option value="2020-09">2020-09</option>
                </select>
            </div><!--/.sort-menu-->
        </div><!--/.box_sort-->
        <p class="search_number">{ state.current_page }</p>
    </div><!--/.container_sort-->

    <template if={ state.total > 0}>
        <div class="contents_block table">
            <table class="contents_table orders_table margin-spacing-3_top">
                <tbody>
                <tr>
                    <th class="orders_table-cell_id" style="width: 8%">プロジェクトID</th>
                    <th class="orders_table-cell_title" style="width: 30%">プロジェクト</th>
                    <th class="orders_table-cell_schedule" style="width: 10%">受注日</th>
                    <th class="orders_table-cell_price" style="width: 9%">金額（税込）</th>
                    <th class="orders_table-cell_client" style="width: 23%">発注元企業</th>
                    <th class="orders_table-cell_status" style="width: 10%">ステータス</th>
                    <th class="orders_table-cell_goto_invoice_page" style="width: 10%">請求書ページ</th>
                </tr>
                <tr each={project in state.projects}>
                    <td class="orders_table-cell_id">{project.project_id}</td>
                    <td class="orders_table-cell_title"><a
                            href="/project/detail/{project.project_id}">{project.title}</a></td>
                    <td class="orders_table-cell_schedule">{project.ordered_date}</td>
                    <td class="orders_table-cell_price">
                        <number-format number={project.amount}/>
                        円
                    </td>
                    <td class="orders_table-cell_client">{project.client_name}</td>
                    <td class="orders_table-cell_status"><span
                            class="status_label project_status_label-{project.state}"></span></td>
                    <td class="orders_table-cell_status">
                        <div class="button button-secondary-mini" summary={summary}
                             onclick={e => gotoInvoiceDetailPage(project.project_id)}>
                            詳細ページへ
                        </div>
                    </td>
                </tr>
                </tbody>
            </table><!--/.contents_table-->
        </div><!--/.contents_block-->
        <edilent-pagination-tag pager="{state.pager}" onpager="{(e,page)=>selectOrder(e,page)}"
                                if={state.pager.last > 1}></edilent-pagination-tag>
    </template>
    <template if={ state.total === 0}>
        <!-- 履歴が存在しない場合　ここから -->
        <div class="empty margin-spacing-3_top">
            <p class="empty-message">表示できる受注履歴はありません。</p>
        </div>
    </template>
    <!-- 履歴が存在しない場合　ここまで -->


    <script>
        import di from "dependency-injection";

        export default {
            state: {
                state: null,
                ym: null,
                projects: [],
                page: 1,
                total: 0,
                pager: {page: 1, total: 0, last: 0, prev: 0, next: 0},
                current_page: ""
            },
            changeOrderState(e) {
                this.state.state = e.target.value;
                this.state.page = 1;
                this.fetchOrders();
            },
            changeOrderYm(e) {
                this.state.ym = e.target.value;
                this.state.page = 1;
                this.fetchOrders();
            },
            selectOrder(e, page) {
                e.preventDefault();
                this.state.page = page;
                this.fetchOrders();
            },
            fetchOrders() {
                const params = {
                    state: this.state.state,
                    ym: this.state.ym,
                    page: this.state.page,
                };
                this.api.request('history', 'fetch-orders', params)
                    .then(data => this.update({
                        projects: data.items,
                        total: data.total,
                        page: data.page,
                        pager: data,
                        current_page: this.generateCurrentPage(data)
                    }));
            },
            generateCurrentPage(data) {
                let dataNum = 10
                if (data.page === data.last) {
                    dataNum = (data.total - (data.last - data.page) * 10)
                }
                return "全" + data.total + "件中" + (10 * (data.page - 1) + 1) + '〜' + dataNum + '件'
            },
            onBeforeMount(props, state) {
                this.api = di.createApi('project');
                this.fetchOrders();
            },
            gotoInvoiceDetailPage(project_id) {
                location.href = '/project/invoice/detail-for-project/' + project_id
            }
        };
    </script>
</orders>
